<template>
  <b-button
    variant="info"
    class="mb-4"
    @click="newModel"
  >
    <b-icon-person-plus-fill
      class="mr-1" />
    新しいメンバー
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'users'
    }
  },

  methods: {
    newModel () {
      this.$router.push({ name: `${this.modelName}-new` })
    }
  }
}
</script>
